import React, { useState } from 'react'
import PropTypes from 'prop-types'

import IconCheck from '../../../../../assets/icons/IconCheck'
import IconPhone from '../../../../../assets/icons/IconPhone'
import useTranslations from '../../../../../i18n/useTranslations'

import Schedule from './Schedule'

const DeliveryPointInfo = ({ data, onClose }) => {
  const t = useTranslations()
  const { businessName, address, schedule, phone } = data

  const [scrollTop, setScrollTop] = useState(0)
  const [scrollBottom, setScrollBottom] = useState(0)

  const handleScroll = event => {
    setScrollTop(event.currentTarget.scrollTop > 0)
    setScrollBottom(
      event.currentTarget.scrollHeight - event.currentTarget.scrollTop ===
        event.currentTarget.clientHeight,
    )
  }
  
  return (
    // <div className={`deliveryPointInfo${distance ? ' is-mapInfo' : 'display-none'}`}>
    <div className={'deliveryPointInfo is-mapInfo'} style={{
      width:window.innerWidth/2.75,
      left: `calc(${window.innerWidth/10}px - 15%)`}}>
      <div className="deliveryPointInfo-closeButton" onClick={onClose}>
        X
      </div>
      <div className="deliveryPointInfo-mainContentWrapper">
        <IconCheck />

        <div className="deliveryPointInfo-mainContent">
          <div className="deliveryPointInfo-businessNameAndAddressContent">
            <p className="deliveryPointInfo-businessName">Punto CTT Express:</p>
            <p className="deliveryPointInfo-businessName">{businessName}</p>
            <p className="deliveryPointInfo-address font-label">{address}</p>
          </div>
          {/* {distance ? (
            <p className="deliveryPointInfo-distance font-label">
              {distance} km
            </p>
          ) : null} */}
        </div>
      </div>
      <div
        className={`deliveryPointInfo-extraInfo ${
          scrollTop ? 'scrolledTop' : ''
        } ${scrollBottom ? 'scrolledBottom' : ''}`}
        onScroll={handleScroll}
      >
        <div className="deliveryPointInfo-extraInfoRow">
          <IconPhone />
          <div className="deliveryPointInfo-extraInfoDataWrapper">
            <p className="deliveryPointInfo-extraInfoLabel font-label">
              {t('noun:phone')}
            </p>
            <p className="deliveryPointInfo-extraInfoData font-h4">{phone}</p>
          </div>
        </div>
        <Schedule schedule={schedule} />
      </div>
    </div>
  )
}

DeliveryPointInfo.propTypes = {
  data: PropTypes.shape({
    businessName: PropTypes.string,
    address: PropTypes.string,
    distance: PropTypes.number,
    schedule: PropTypes.string,
    phone: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
}

export default DeliveryPointInfo
